import { createContext } from 'react'

const CookieBannerContext = createContext()

export default CookieBannerContext
